import {IOfferFromJSON} from '../../../../types';
import {NO_PATTERN_BUSINESS_LOGIC, Price} from '@vfde-brix/core';
import {IPromoPriceProperties} from '@vfde-brix/promo-price';
import {IHighlightBadgeProperties} from '@vfde-brix/highlight-badge';
import {IJustTextProperties} from '@vfde-brix/just-text';
import {IButtonProperties} from '@vfde-brix/button';
import {
    createOfferPriceComponent,
    IOfferPriceProperties,
    IOfferPriceButtonProperties, IOfferPriceBusinessLogic,
} from '@vfde-brix/offer-price';
import {
    MAX_LEGALTEXT_ITEMS,
    OFFER_CARD_OFFER_PRICE,
    OFFER_CARD_OFFER_PRICE_CTA,
} from 'Container/OfferDisplay/constant';
import {getFormattedFootnote} from 'Container/OfferDisplay/helpers/renderers/footnotesRenderHelper';
import { handleButtonClickEvent } from '../eventHelper';

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * FIND STRUCTURE OF PRICE DETAILS IN readme.md
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

const generateLegalText = (offer: IOfferFromJSON): IJustTextProperties => {

    let legalText = '';

    for (let i = 0; i < MAX_LEGALTEXT_ITEMS; i++) {
        if ('' !== offer[`Total_Subline_${i + 1}`]) {
            if ('' !== legalText) {
                legalText += '<br />';
            }
            legalText += offer[`Total_Subline_${i + 1}`];
        }
    }

    if ('' !== legalText) {
        const legalTextProperties: IJustTextProperties = {
            content: legalText,
            tag: 'p',
            business: NO_PATTERN_BUSINESS_LOGIC,
        };

        return legalTextProperties;
    } else {
        return null;
    }

};

/**
 * renders the offer price dynamically
 * @param element
 * @param offer
 */
export const renderOfferPrice = (element: HTMLElement, offer: IOfferFromJSON, buttonClickAction) => {

    const offerPriceElement: HTMLElement = <HTMLElement>element.getElementsByClassName(OFFER_CARD_OFFER_PRICE)[0];

    const tariffInfoProperties: IJustTextProperties[] = [{
        content: `<strong>${offer.Bundle_Name}</strong>` + getFormattedFootnote(offer.Price_FN),
        className: 'brix-h3-style',
        tag: 'p',
        business: NO_PATTERN_BUSINESS_LOGIC,
    }];

    const highLightBadgeProperties: IHighlightBadgeProperties = {
        color: 'turquoise',
        content: '<p>' + offer.Badge + getFormattedFootnote(offer.Badge_FN) + '</p>',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    const promoPricePoperties: IPromoPriceProperties[] = [{
        price: Price.fromString(offer.Total_wDiscount_BigPrice),
        stdAdditionalText: 'pro Monat',
        optShowCentsAlways: false,
        optSizeVariation: 'large',
        business: NO_PATTERN_BUSINESS_LOGIC,
    }];

    const buttonPoperties: IButtonProperties = {
        optShape: 'rectangle',
        optWidthVariation: 'hybrid',
        optColor: 'strong',
        size: 'large',
        content: offer.CTA_Label,
        href: offer.CTA_Link_Tariff,
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    const offerPriceButtonProperties: IOfferPriceButtonProperties[] = [{
        stdButtonWrapperId: OFFER_CARD_OFFER_PRICE_CTA,
        buttonProperties: buttonPoperties,
    }];

    const offerPriceBusinessLogic: IOfferPriceBusinessLogic = {
        onButtonClicks: [
            { stdButtonWrapperId: OFFER_CARD_OFFER_PRICE_CTA,
                buttonBusiness: {
                    onClick: (e) => {
                        handleButtonClickEvent(e, buttonClickAction);
                    },
                },
            },
        ],
    };

    const offerPrice: IOfferPriceProperties = {
        optHighlightBadgePositionBottom: false,
        highlightBadge: highLightBadgeProperties,
        tariffInfo: tariffInfoProperties,
        legal: generateLegalText(offer),
        price: promoPricePoperties,
        button: offerPriceButtonProperties,
        business: offerPriceBusinessLogic,
    };

    createOfferPriceComponent(offerPriceElement, offerPrice);

};
